import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAuth } from "../../provider/AuthProvider";
import { spvSidebarData } from "../../core/common/data/json/spv-sidebar";
import { instructorSidebarData } from "../../core/common/data/json/instructor-sidebar";

interface ProtectedRouteProps {
  roles?: ("admin" | "supervisor" | "user")[];
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ roles }) => {
  const { isAuthenticated, role } = useAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (roles && !roles.includes(role!)) {
    return <Navigate to="/404" replace />;
  }

  const currentPath = location.pathname;

  // helper to match dynamic route patterns
  const matchRoute = (path: string, pattern: string) => {
    const regex = new RegExp("^" + pattern.replace(/:[^/]+/g, "[^/]+") + "$");
    return regex.test(path);
  };

  // supervisor allowed routes (including manual ones)
  const supervisorAllowedRoutes = [
    ...spvSidebarData.map((item) => item.route),
    "/admin/courses/analytics/:id", // add dynamic allowed route
  ];

  const instructorRoutes = instructorSidebarData.map((item) => item.route);

  if (role === "supervisor") {
    const isAllowed = supervisorAllowedRoutes.some((r) =>
      matchRoute(currentPath, r)
    );
    const isInstructorOnly = instructorRoutes.some((r) =>
      matchRoute(currentPath, r)
    );

    if (isInstructorOnly && !isAllowed) {
      return <Navigate to="/404" replace />;
    }
  }

  return <Outlet />;
};

export default ProtectedRoute;